import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import styles from './signContainer.module.scss';
import Sign from './sign.jsx';
import { Button } from 'antd-mobile-v5';
import { Toast } from 'antd-mobile';
function LaborAgreement(props, refs) {

    const [imgUrl, setImgUrl] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [reSign, setReResign] = useState(false);
    const signRef = useRef();
    useEffect(() => {
        return () => {
        }
    }, [])

    // 展示弹框
    useImperativeHandle(refs, () => ({
        toShowModal,
        getIsDrawed
    }));

    // 更新签名图片
    const toUpdateImgUrl = (url) => {
        setImgUrl(url)
        props.updateSignUrl(url);
        setShowModal(false);
    }
    // 清除签名图片
    const toClearSignUrl = () => {
        signRef.current.toClearImg();
    }
    // 保存更新签名图片
    const toUpdateSignUrl = () => {
        const _isDrawed = signRef.current.toGetIsDrawed();
        if (!_isDrawed) {
            Toast.info('请确认是否已经签名', 0.8);
            return;
        }
        signRef.current.toSaveImgInfo();
    }
    // 获取是否有过签名
    const getIsDrawed = () => {
        const _isDrawed = signRef.current.toGetIsDrawed();
        return _isDrawed;
    }
    // 展示弹框
    const toShowModal = (param = {
        resign: false
    }) => {
        if (param.resign) {
            // 重新签名不清除之前的手签
            setReResign(true);
        } else {
            // 开始签名清除之前的手签
            toClearSignUrl();
        }
        setShowModal(true);
    }
    // 关闭弹框
    const toHideModal = () => {
        // 重新签名不清除之前的手签
        if (reSign == false) {
            toClearSignUrl();
        }
        setShowModal(false);
    }

    return (
        <div className={`${styles.signContainer_content} ${showModal ? '' : styles.hide}`}>
            <div className={styles.modal_content}>
                <div className={styles.sign_wrap}>
                    <Sign className={styles.sign_extra} updateImgUrl={toUpdateImgUrl} ref={signRef}></Sign>
                </div>
                <div className={styles.warn_text}>请在上面的方框内签名</div>
                <div className={styles.sign_btn}>
                    <div>
                        <Button color='primary' fill='outline' onClick={toHideModal} >关闭</Button>
                    </div>
                    <div>
                        <Button className={styles.btn_clear} color='primary' fill='solid' onClick={toClearSignUrl} >清除</Button>
                        <Button color='primary' fill='solid' onClick={toUpdateSignUrl} >确认</Button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default forwardRef(LaborAgreement);